import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import { setResultModalData, showModal, showNestedModal } from "../modal/modalSlice";
import { toast } from "react-toastify";
import axios from "axios";

const initialState = {
  companyProfileInfo: null,
  topBarCompanyInfo: null,

  surucuList: [],
  
  companyInfoValues: {
      companyTaxNo: "",
      companyVergiDairesi: "",
      companyName: "",
      companyShortName: "",
      firmaType: "",
      companyPhoneNumber: "",
      companyMail: "",
      companyAddress: "",
      companyCityTown: "",
      companyLocation: "",
      companyLat: "",
      companyLng: "",
      billTitle: "",
      bankAccountOwner: "",
      bankIBANNo: "",
      kolayAdresType: "",
      kolayAdres: "",
      gibUsername: "",
      gibPassword: ""
  },
  
  companyDocs: {
      logo1: "", 
      logo2: "",
      vergiLevhasi: "",
      kase: "",
      faturaBaslik: "",
      companyOzelPhoto1: "",
      companyOzelPhoto2: "",
      companyOzelPhoto3: "",
  },

  isEditableCompanyInfo: false,

  isLoadingGetCompany: false,
  isErrorGetCompany: false,
  isLoadingGetTopBarCompany: false,
  isErrorGetTopBarCompany: false,
  isLoadingUpdateCompany: false,
  isErrorUpdateCompany: false,

  companyDocs: null,
  
  isLoadingGetCompanyDocs: false,

  isLoadingUpdateCompanyDocs: false,

  companyAracItem: null,

  companyAracItemDocs: {
    ruhsat: "",
    tasitKarti: "",
    saseFoto: "",
    trafikSigortaPolice: "",
    yukSigortaPolice: "",
    aracFotoOndenSurucu: "",
    aracFotoOnden: "",
    aracFotoYandan: "",
    aracFotoArkadan: "",
    diger1:""
  },

  surucuSorguInfo:null,

  isLoadingUpdateCompanyAracItemDocs: false,

  ozVarlikAracList: [],
  isLoadingAddOzvarlik: false,
  isLoadingGetOzvarlik: false,
  isLoadingDeleteOzvarlik: false,
  isLoadingGetSurucu:false,
  isLoadingDeleteSurucu:false,
  isLoadingSurucuSorgu: false,
  isLoadingProfile: false,
  isErrorProfile: false

}


const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;

//! getCompanyDocs
export const getCompanyDocs = createAsyncThunk("companyProfile/getCompanyDocs", async(_, thunkApi) => {
    try{
      const {data} = await axiosInstance.get(`Companies/GetCompanyDoc`)
      return data.data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
})


//! updateCompanyDocs
export const updateCompanyDocs = createAsyncThunk("companyProfile/updateCompanyDocs", async({list, companyId}, thunkApi) => {
    try{

        const editId = companyId.replace(/"/g, '')
        const formData = new FormData();
        list.forEach((document, index) => {
          formData.append(`uploadCompanyDocs[${index}].CompanyId`, editId);
          formData.append(`uploadCompanyDocs[${index}].DocumentName`, document.docName);
          formData.append(`uploadCompanyDocs[${index}].File`, document.doc);
        });
 

      const {data} = await axiosInstance.post(`Companies/UpdateCompanyDoc`, formData )

        if(data.statusCode === 200){
          toast.success(`Belge Güncelleme İşlemi Başarı İle Gerçekleştirildi.`, {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          thunkApi.dispatch(getCompanyDocs())
        }
        else{
          toast.error(`Bir hata meydana geldi, lütfen daha sonra tekrar deneyin.`, {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }


    //   if(data.statusCode === 200){
    //     thunkApi.dispatch(showModal("result"))
    //     thunkApi.dispatch(setResultModalData({msg: "Belge yükleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Harika"}))
    //     thunkApi.dispatch(getCompanyDocs())
    // }
      return data
    }catch(error){
      return thunkApi.rejectWithValue(error)
    }
  })


  //! deleteCompanyDoc
export const deleteCompanyDoc = createAsyncThunk("companyProfile/deleteCompanyDoc", async(docName, thunkApi) => {
  try{

    const {data} = await axiosInstance.delete(`${process.env.REACT_APP_API_URI}/Companies/CompanyDocument?documentName=${docName}`)

      if(data.statusCode === 200){
        toast.success(`Belge Güncelleme İşlemi Başarı İle Gerçekleştirildi.`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        thunkApi.dispatch(getCompanyDocs())
      }
      else{
        toast.error(`Bir hata meydana geldi, lütfen daha sonra tekrar deneyin.`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }


  //   if(data.statusCode === 200){
  //     thunkApi.dispatch(showModal("result"))
  //     thunkApi.dispatch(setResultModalData({msg: "Belge yükleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Harika"}))
  //     thunkApi.dispatch(getCompanyDocs())
  // }
    return data
  }catch(error){
    return thunkApi.rejectWithValue(error)
  }
})






  export const getCompanyInfo = createAsyncThunk("getCompanyInfo", async(_, thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/Companies/GetCompanyInfo`)
        return data.data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})

export const getTopBarCompanyInfo = createAsyncThunk("getTopBarCompanyInfo", async(_, thunkApi) => {
    try{
        const {data} = await axiosInstance.get(`/Companies/GetCompanyIdInfo`)
        return data.data
      }catch(error){
        return thunkApi.rejectWithValue(error)
      }
})

export const updateCompanyInfo = createAsyncThunk("updateCompanyInfo", async(body, thunkApi) => {
    try{
        const {data} = await axiosInstance.post(`/Companies/UpdateCompanyInfo`, body)
        if(data.statusCode === 200){
            thunkApi.dispatch(setEditableCompanyInfo()); 
        }
        
        return data.data
    }catch(error){
        return thunkApi.rejectWithValue(error)
    }
})


export const profilOzVarlikAracEkle = createAsyncThunk("profilOzVarlikAracEkle", async(body, thunkApi) => {
  try{
      const {data} = await axiosInstance.post(`/TruckTrailer/AddTruckTrailerFromClientTekliWebProfile`, body)

      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Araç yükleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Harika"}))
      }
      return data.data
  }catch(error){
      return thunkApi.rejectWithValue(error)
  }
})

export const getProfilOzVarlikArac = createAsyncThunk("getProfilOzVarlikArac", async(query, thunkApi) => {
  try{
      const {data} = await axiosInstance.get(`/TruckTrailer/GetTrailerAndTruckCompanyProfiles?Plate=${query}`)

      return data.data
  }catch(error){
      return thunkApi.rejectWithValue(error)
  }
})

export const profilOzVarlikAracGuncelleme = createAsyncThunk("profilOzVarlikAracGuncelleme", async(body, thunkApi) => {
  try{
      const {data} = await axiosInstance.post(`/TruckTrailer/UpdateTruckTrailerFromClientTekliWebProfile`, body)

      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Araç güncelleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Harika"}))
      }
      return data.data
  }catch(error){
      return thunkApi.rejectWithValue(error)
  }
})

export const profilOzVarlikAracSilme = createAsyncThunk("profilOzVarlikAracSilme", async(query, thunkApi) => {
  try{
      const {data} = await axiosInstance.post(`/TruckTrailer/DeleteTruckOrTrailerCompanyProfile?PlateNumber=${query}`)

      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Araç silme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Harika"}))
      }
      return data.data
  }catch(error){
      return thunkApi.rejectWithValue(error)
  }
})

export const updateCompanyAracItemDocs = createAsyncThunk("companyProfile/updateCompanyAracItemDocs", async({list, plate}, thunkApi) => {
  try{
      const formData = new FormData();
      list.forEach((document, index) => {
          formData.append(`uploadProfileTruckAndTrailers[${index}].Plate`, plate);
          formData.append(`uploadProfileTruckAndTrailers[${index}].DocumentName`, document.docName);
          formData.append(`uploadProfileTruckAndTrailers[${index}].File`, document.doc);
      });


    const {data} = await axiosInstance.post(`TruckTrailer/UpdateTruckAndTrailerCompanyDoc`, formData )
    if(data.statusCode === 200){
      toast.success(`Belge Güncelleme İşlemi Başarı İle Gerçekleştiridi.`, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    else{
      toast.error(`Bir hata meydana geldi, lütfen daha sonra tekrar deneyin.`, {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    return data
  }catch(error){
    return thunkApi.rejectWithValue(error)
  }
})


export const profilSurucuSorgu = createAsyncThunk("profilSurucuSorgu", async(query, thunkApi) => {
  try{
      const {data} = await axiosInstance.get(`/User/GetDriverPhoneNumber?PhoneNumber=${query}`)
      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("profilSurucuSearchDetail"))
      }
      return data.data
  }catch(error){
      thunkApi.dispatch(showModal("addProfilimSuruculerim"))
      return thunkApi.rejectWithValue(error)
  }
})

export const profilSurucuEkle = createAsyncThunk("profilSurucuEkle", async(body, thunkApi) => {
  try{
      const {data} = await axiosInstance.post(`/User/AddDriver`, body)

      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Sürücü ekleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Harika"}))
      }
      return data.data
  }catch(error){
      return thunkApi.rejectWithValue(error)
  }
})


export const profilSurucuGet = createAsyncThunk("profilSurucuGet", async({PhoneNumber = "", AdSoyadUnvan = ""}, thunkApi) => {
  try{
      const {data} = await axiosInstance.get(`/User/GetDriver?PhoneNumber=${PhoneNumber}&AdSoyadUnvan=${AdSoyadUnvan}`)

      return data.data
  }catch(error){
      return thunkApi.rejectWithValue(error)
  }
})

export const profilSurucuSilme = createAsyncThunk("profilSurucuSilme", async(id, thunkApi) => {
  try{
      const {data} = await axiosInstance.post(`/User/DeleteDriver?UserId=${id}`)

      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Sürücü silme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Harika"}))
      }
      return data.data
  }catch(error){
      return thunkApi.rejectWithValue(error)
  }
})

export const profilKayitliSurucuEkle = createAsyncThunk("profilKayitliSurucuEkle", async(body, thunkApi) => {
  try{
      const {data} = await axiosInstance.post(`/User/SavedDriver`, body)
      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Ekleme talebiniz sürücüye iletilmiştir. Onay verildiği takdirde sürücülerinize eklenecektir.", resultType: "success", btnText1: "Harika"}))
      }
      
      return data.data
  }catch(error){
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: error.response.data.ErrorDto.Errors[0], resultType: "error", btnText1: "Tamam"}))
      return thunkApi.rejectWithValue(error)
  }
})

const companyProfileSlice = createSlice({
    name: "companyProfile",
    initialState,
    reducers: {
        setCompanyInfoValues: (state, action) => {
          state.companyInfoValues = {...state.companyInfoValues, ...action.payload}
        },

        setEditableCompanyInfo: (state, action) => {
          state.isEditableCompanyInfo = !state.isEditableCompanyInfo
        },

        setCompanyAracItem: (state, action) => {
          state.companyAracItem = action.payload
        },
        
    },
    extraReducers:(builder)=> {
        builder
        
        // getCompanyDocs
        .addCase(getCompanyDocs.pending, (state)=> {
            state.isLoadingGetCompanyDocs = true

        })
        .addCase(getCompanyDocs.fulfilled, (state, action)=> {
            state.isLoadingGetCompanyDocs = false
            state.companyDocs = action.payload
        })

        .addCase(getCompanyDocs.rejected, (state, action)=> {
            state.isLoadingGetCompanyDocs = false
        })

        // updateCompanyDocs
        .addCase(updateCompanyDocs.pending, (state)=> {
          state.isLoadingUpdateCompanyDocs = true
        })
        .addCase(updateCompanyDocs.fulfilled, (state, action)=> {
            state.isLoadingUpdateCompanyDocs = false
        })
        .addCase(updateCompanyDocs.rejected, (state, action)=> {
            state.isLoadingUpdateCompanyDocs = false
        })
        


          .addCase(getCompanyInfo.pending, (state) => {
              state.isLoadingGetCompany = true;
          })
          .addCase(getCompanyInfo.fulfilled, (state, action) => {
              state.isLoadingGetCompany = false;
              state.companyProfileInfo = action.payload
          })
          .addCase(getCompanyInfo.rejected, (state) => {
              state.isErrorGetCompany = true
              state.isLoadingGetCompany = false;
          })
  
          .addCase(getTopBarCompanyInfo.pending, (state) => {
              state.isLoadingGetTopBarCompany = true;
          })
          .addCase(getTopBarCompanyInfo.fulfilled, (state, action) => {
              state.isLoadingGetTopBarCompany = false;
              state.topBarCompanyInfo = action.payload
              storage.setItem("cShortName", JSON.stringify(action.payload.companyShortName))
              storage.setItem("cPhoneNumber", JSON.stringify(action.payload.yetkiliPhoneNumber))
          })
          .addCase(getTopBarCompanyInfo.rejected, (state) => {
              state.isErrorGetTopBarCompany = true
              state.isLoadingGetTopBarCompany = false;
          })
  
          .addCase(updateCompanyInfo.pending, (state) => {
              state.isLoadingUpdateCompany = true;
          })
          .addCase(updateCompanyInfo.fulfilled, (state, action) => {
              state.isLoadingUpdateCompany = false;
              state.companyProfileInfo = action.payload
          })
          .addCase(updateCompanyInfo.rejected, (state) => {
              state.isErrorUpdateCompany = true
              state.isLoadingUpdateCompany = false;
          })

          .addCase(profilOzVarlikAracEkle.pending, (state) => {
            state.isLoadingAddOzvarlik = true;
          })
          .addCase(profilOzVarlikAracEkle.fulfilled, (state, action) => {
              state.isLoadingAddOzvarlik = false;
              state.ozVarlikAracList = [...state.ozVarlikAracList, action.payload]
          })
          .addCase(profilOzVarlikAracEkle.rejected, (state) => {
              state.isLoadingAddOzvarlik = false;
          })

          .addCase(getProfilOzVarlikArac.pending, (state) => {
            state.isLoadingGetOzvarlik = true;
          })
          .addCase(getProfilOzVarlikArac.fulfilled, (state, action) => {
              state.isLoadingGetOzvarlik = false;
              state.ozVarlikAracList = action.payload.$values
          })
          .addCase(getProfilOzVarlikArac.rejected, (state) => {
              state.isLoadingGetOzvarlik = false;
          })

          .addCase(profilOzVarlikAracGuncelleme.pending, (state) => {
            state.isLoadingAddOzvarlik = true;
          })
          .addCase(profilOzVarlikAracGuncelleme.fulfilled, (state, action) => {
              state.isLoadingAddOzvarlik = false;
              state.ozVarlikAracList = state.ozVarlikAracList.map((item) => {
                const findData = item.id === action.payload.id
                if(findData){
                  return {...item, ...action.payload}
                }else{
                  return item
                }
              })
          })
          .addCase(profilOzVarlikAracGuncelleme.rejected, (state) => {
              state.isLoadingAddOzvarlik = false;
          })

          .addCase(profilOzVarlikAracSilme.pending, (state) => {
            state.isLoadingDeleteOzvarlik = true;
          })
          .addCase(profilOzVarlikAracSilme.fulfilled, (state, action) => {
              state.isLoadingDeleteOzvarlik = false;
              state.ozVarlikAracList = state.ozVarlikAracList.filter((item) => {
                return item.id !== action.payload.id
              })
          })
          .addCase(profilOzVarlikAracSilme.rejected, (state) => {
              state.isLoadingDeleteOzvarlik = false;
          })
          .addCase(updateCompanyAracItemDocs.pending, (state) => {
            state.isLoadingUpdateCompanyAracItemDocs = true;
          })
          .addCase(updateCompanyAracItemDocs.fulfilled, (state, action) => {
              state.isLoadingUpdateCompanyAracItemDocs = false;
              state.ozVarlikAracList = state.ozVarlikAracList.map((item) => {
                if(item.id === action.payload.data.id){
                  return action.payload.data
                }
                else{
                  return item
                }
              })
              state.companyAracItem = action.payload.data
          })
          .addCase(updateCompanyAracItemDocs.rejected, (state) => {
              state.isLoadingUpdateCompanyAracItemDocs = false;
          })

          .addCase(profilSurucuEkle.pending, (state) => {
            state.isLoadingAddOzvarlik = true;
          })
          .addCase(profilSurucuEkle.fulfilled, (state, action) => {
              state.isLoadingAddOzvarlik = false;
              state.surucuList = [...state.surucuList, action.payload]
          })
          .addCase(profilSurucuEkle.rejected, (state) => {
              state.isLoadingAddOzvarlik = false;
          })

          .addCase(profilSurucuGet.pending, (state) => {
            state.isLoadingGetSurucu = true;
          })
          .addCase(profilSurucuGet.fulfilled, (state, action) => {
              state.isLoadingGetSurucu = false;
              state.surucuList = action.payload.$values
          })
          .addCase(profilSurucuGet.rejected, (state) => {
              state.isLoadingGetSurucu = false;
          })

          
          .addCase(profilSurucuSilme.pending, (state) => {
            state.isLoadingDeleteSurucu = true;
          })
          .addCase(profilSurucuSilme.fulfilled, (state, action) => {
              state.isLoadingDeleteSurucu = false;
              state.surucuList = state.surucuList.filter((item) => {
                return item.id !== action.payload.id
              })
          })
          .addCase(profilSurucuSilme.rejected, (state) => {
              state.isLoadingDeleteSurucu = false;
          })
          

          .addCase(profilSurucuSorgu.pending, (state) => {
            state.isLoadingSurucuSorgu = true;
          })
          .addCase(profilSurucuSorgu.fulfilled, (state, action) => {
              state.isLoadingSurucuSorgu = false;
              state.surucuSorguInfo = action.payload
          })
          .addCase(profilSurucuSorgu.rejected, (state) => {
              state.isLoadingSurucuSorgu = false;
          })

          .addCase(profilKayitliSurucuEkle.pending, (state) => {
            state.isLoadingAddOzvarlik = true;
          })
          .addCase(profilKayitliSurucuEkle.fulfilled, (state, action) => {
              state.isLoadingAddOzvarlik = false;
              state.surucuList = [...state.surucuList, action.payload]
          })
          .addCase(profilKayitliSurucuEkle.rejected, (state) => {
              state.isLoadingAddOzvarlik = false;
          })

    }
})

export const {setEditableCompanyInfo, setCompanyInfoValues, setCompanyAracItem} = companyProfileSlice.actions
export default companyProfileSlice.reducer